import { Pipe, PipeTransform } from '@angular/core';
import {Constants} from '../constants';

@Pipe({
  name: 'operatorTranslate'
})
export class OperatorTranslatePipe implements PipeTransform {

  transform(value: string): any {

    const operator = Constants.OPERATORS.find((op) => op.label === value);
    return operator ? operator.translation : value;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/pipes/operator-translate.pipe.ts